// extracted by mini-css-extract-plugin
export var topAnchor = "v_gt";
export var topLevelMenu = "v_gv";
export var dropdownWrapper = "v_gw";
export var dropdownItem = "v_gx";
export var subMenu = "v_gy";
export var dropdownAnchor = "v_gz";